import React from "react"
import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import styled from "styled-components"
import { down } from "styled-breakpoints"
//DATA
import { list } from "../../assets/data/pageStructure"
//STYLED
import { Container } from "../../utils/utils"
//COMPONENTS
import NavMobile from "./navbarMobile/NavMobile"
import HamburgerMenuIcon from "./navbarMobile/HamburgerMenuIcon"
import LogoMobile from "./navbarMobile/LogoMobile"
import { LinkedIn } from "../../assets/images/svg/elements"

const navbarItemCount = (() => {
  if (list && typeof list === "object") {
    return Object.keys(list).length + 1 // Dodajemy 1 dla stałego elementu, np. "Home".
  }
  return 1 // Wartość domyślna, gdy `list` jest nieprawidłowy.
})()
const navbarHeight = "70px"

const Nav = styled.nav`
  position: sticky;
  top: 0;
  z-index: 200;
  height: ${navbarHeight};
  width: 100%;
  box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.1);
  background-color: rgba(255, 255, 255, 1);
  ${down("sm")} {
    display: none;
  }
`

const NavbarWrapper = styled(Container)`
  display: flex;
  justify-content: space-between;
`

const NavbarItemWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(${navbarItemCount}, minmax(100px, 1fr));
  justify-self: center;
`

const NavbarItem = styled(Link)`
  text-align: center;
  padding: 0 1.5rem;
  display: grid;
  align-items: center;
  width: 100%;
  white-space: pre-wrap;
  cursor: pointer;
  background-color: transparent;
  color: ${({ theme }) => theme.color.font};
  font-size: 20px;
  font-weight: 400;
  line-height: 1.1;
  border-style: solid;
  border-width: 0 0 5px 0;
  border-color: transparent;
  transition: all 0.5s;

  svg {
    transition: all 0.5s;
    height: 40px;
    width: auto;
    padding: 0 auto;
    justify-self: center;
  }

  &.active,
  :hover {
    color: ${({ theme }) => theme.color.base1};
    border-color: ${({ theme }) => theme.color.base1};

    svg {
      fill: ${({ theme }) => theme.color.base1};
    }
  }
`

const Logo = styled(Link)`
  padding: 0.5rem 1rem 0.5rem 0;
  display: block;
  height: ${navbarHeight};
  div {
    height: 100% !important;
  }
`

class Navbar extends React.Component {
  state = { clicked: false }

  handleClick = () => {
    this.setState({ clicked: !this.state.clicked })
  }

  render() {
    const menu = list.map(item => (
      <NavbarItem
        activeClassName="active"
        key={item.name}
        to={this.props.lang === "pl-PL" ? item.path : "/en" + item.path}
      >
        {this.props.lang === "pl-PL" ? item.name : item.nameEn}
      </NavbarItem>
    ))

    return (
      <>
        {/*BELKA NAWIGACJI*/}
        <Nav id="menu" role="navigation" aria-label="main navigation">
          <NavbarWrapper>
            <Logo to="/">
              <StaticImage
                src="../../assets/images/logo/logo.png"
                alt="Logo"
                objectPosition="center left"
                objectFit="contain"
                placeholder="blurred"
              />
            </Logo>

            <NavbarItemWrapper>
              {menu}
              <NavbarItem
                target="blank"
                href="https://www.linkedin.com/company/elcam-sp-z-o-o/"
              >
                <LinkedIn />
              </NavbarItem>
            </NavbarItemWrapper>
          </NavbarWrapper>
        </Nav>
        {/*LOGO MOBILNE*/}
        <LogoMobile slug={this.props.slug} />

        {/*MENU MOBILNE*/}
        {/* <motion.div
                animate={this.state.clicked ? "open" : "closed"}
                variants={variants}>

                <NavMobile>
                    {menu}
                </NavMobile>
            </motion.div> */}

        {this.state.clicked ? (
          <NavMobile top="0" opacity="1">
            {menu}
          </NavMobile>
        ) : (
          <NavMobile></NavMobile>
        )}

        {/*IKONKA HAMBURGER MENU POJAWIAJĄCE SIĘ TYLKO NA MOBILNYCH*/}
        <HamburgerMenuIcon
          onClick={this.handleClick}
          state={this.state.clicked}
        />
      </>
    )
  }
}
export default Navbar
